<div
    [ngClass.xs]="{ 'generic-listing-page': true }"
    [ngClass.gt-xs]="{ 'desktop-generic-listing': true }"
    [ngStyle.gt-xs]="{ margin: dataDialog?.popup ? '0' : '36px 30px' }"
    fxLayout="column"
    class="glp-container"
>
    <h1 style="font-size: 18px; margin-bottom: 25px">{{
        pageData?.title?.text
    }}</h1>
    <img
        style="position: absolute; right: 20px; top: 36px; cursor: pointer"
        (click)="closeDialog()"
        src="https://images.dailyobjects.com/icons/cross.png"
        class="icon"
    />
    <app-popup-shimmer *ngIf="showShimmer"></app-popup-shimmer>

    <a
        *ngFor="let item of pageData?.feed"
        fxLayout="column"
        class="dialog-anchor"
        (click)="processLink(item?.link); dialogRef.close()"
    >
        <div
            fxLayout="row"
            [ngStyle.xs]="{ width: '80vw !important' }"
            fxLayoutAlign="space-around center"
        >
            <p style="padding: 10px" class="anchor-text">{{ item?.text }}</p>
            <img style="width: 20px" src="{{ item?.icon }}" appImageCDN />
        </div>
    </a>
</div>
